import type { TransactionLinkedLeg, TransferLinkRule, TransferLinkRulePayload, TransferLinkSuggestion } from "../types";
import { api } from "./core";

export const linkedTransactionsApi = {
  transferLinkRules: (groupId: string) => api<TransferLinkRule[]>("/transfer-links/rules", { groupId }),
  createTransferLinkRule: (groupId: string, payload: TransferLinkRulePayload) =>
    api<TransferLinkRule>("/transfer-links/rules", { method: "POST", body: JSON.stringify(payload), groupId }),
  updateTransferLinkRule: (groupId: string, id: string, payload: TransferLinkRulePayload) =>
    api<TransferLinkRule>(`/transfer-links/rules/${id}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  deleteTransferLinkRule: (groupId: string, id: string) =>
    api<void>(`/transfer-links/rules/${id}`, { method: "DELETE", groupId }),

  transferLinkSuggestions: (groupId: string) => api<TransferLinkSuggestion[]>("/transfer-links/suggestions", { groupId }),
  scanTransferLinkSuggestions: (groupId: string) =>
    api<TransferLinkSuggestion[]>("/transfer-links/suggestions/scan", { method: "POST", groupId }),
  confirmTransferLinkSuggestion: (groupId: string, id: string) =>
    api<void>(`/transfer-links/suggestions/${id}/confirm`, { method: "POST", groupId }),
  dismissTransferLinkSuggestion: (groupId: string, id: string) =>
    api<void>(`/transfer-links/suggestions/${id}/dismiss`, { method: "POST", groupId }),

  linkCandidates: (groupId: string, transactionId: string) =>
    api<TransactionLinkedLeg[]>(`/transfer-links/candidates/${transactionId}`, { groupId }),
  linkTransactions: (groupId: string, transactionId: string, partnerTransactionId: string) =>
    api<void>("/transfer-links/link", {
      method: "POST",
      body: JSON.stringify({ transaction_id: transactionId, partner_transaction_id: partnerTransactionId }),
      groupId,
    }),
  unlinkTransaction: (groupId: string, transactionId: string) =>
    api<void>(`/transfer-links/${transactionId}/unlink`, { method: "POST", groupId }),
};
